import React from 'react'
import {Link, Route} from 'react-router-dom'
import {Layout,  Icon} from 'antd'


const {Header} = Layout


const Home = () => {
    return (
        <Layout style={{minHeight: '100vh'}}>
            <Header className="header">
                <div className="logo" />
                <Link to="/login">
                    <Icon type="user"/>
                    <span>Login</span>
                </Link>
            </Header>

        </Layout>
    )
}

export default Home
